import { mapActions } from "vuex";
import { GET_USER_REPORTS, GET_USER_SUBSCRIPTION, GENERATE_LAST_PORTFOLIO_INSIGHT } from '@/store/actions.type'
import portfolioScoreCard from './../../components/portfolioScoreCard.vue'
import {CSVExport} from '../../mixins/CSVExport'
import axios from 'axios';
import legalagreementpostpayment from "../../components/legalagreementpostpayment.vue";
import { data } from "jquery";
export default {
  mixins: [CSVExport],
  data() {
    return {
      isPrem: null,
      isOverviewVisited: true,
      isReportsVisited: false,
      isSettingsVisited: false,
      openPastPortfolioDialog: false,
      pastPortfolioData: {},
      filterIcon: `<svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.25 0.333328V1.49999H10.6667L7.16667 6.74999V10.8333H4.83333V6.74999L1.33333 1.49999H0.75V0.333328H11.25Z" fill="black"/>
            </svg>`,
      downloadIcon: `<svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.66634 4.66667H10.9997L6.99967 8.66667L2.99967 4.66667H6.33301V0H7.66634V4.66667ZM1.66634 10.6667H12.333V6H13.6663V11.3333C13.6663 11.5101 13.5961 11.6797 13.4711 11.8047C13.3461 11.9298 13.1765 12 12.9997 12H0.999674C0.822863 12 0.653294 11.9298 0.52827 11.8047C0.403246 11.6797 0.333008 11.5101 0.333008 11.3333V6H1.66634V10.6667Z" fill="black"/>
            </svg>`,
      modalShow: false,
      fields: [{ key: 'updatedDate', label: 'Date' }, { key: 'trade', label: 'Trade Details'}, 'select'],
      reportsTableData: null,
      totalPremReports: [],
      lastPortfolioInsight:null,
      isPremium: false,
      showEsign:false,
			legalAgreementContentEsign:"",
			esignRecord:null,
			isEsignActive:false
    }
  },
  components: {portfolioScoreCard, legalagreementpostpayment},
  created() {
    this.setEnableReport(false);
    this.fetchusersubscription();
    this.fetchUserReports();
    this.checkauth();
  },
  computed : {
    subscription () {
      return this.$store.state.home.subscription;
    },
    userData () {
      return this.$store.state.authentication.user;
    }
  },

  watch:  {
    subscription(val) {
      if(val && val.remainingAccess) {
        this.modalShow = true;
      }
    }
  },
  methods: {
    ...mapActions({
      getuserreports: GET_USER_REPORTS, getusersubscription: GET_USER_SUBSCRIPTION,

    }),

    ...mapActions("addholdings", {
      generatelastportfolio:GENERATE_LAST_PORTFOLIO_INSIGHT,
      setEnableReport: "setEnableReport",
    }),

    async checkauth () {
			if (localStorage.getItem('psitoken')) {
				this.isLoggedin = true;
				this.checkEsignStatus();
			}
			else {
				this.isLoggedin = false;
			}
		},

    async fetchUserReports() {
      var self = this;
      await this.getuserreports().then(data => {
        if (data && data.length > 0) {
          var PremReports = data.filter(report => {
            return report.inputData != '';
          });

          //Exporting from Output data
          // PremReports.forEach(rep => {
          //   JSON.parse(rep.inputData).map(el => {
          //     if(el) {
          //       var newItem = {};
          //       newItem.id = el.user_portfolio[0].id;
          //       newItem.Name = el.user_portfolio[0].Name;
          //       newItem.Total = el.user_portfolio[0].Total;
          //       newItem.price = el.user_portfolio[0].price;
          //       csvData.push(newItem);
          //     }
          //   })
          // })

          this.generatelastportfolioinsight(data[0]);

          //Exporting from input data but Type is not available
          PremReports.forEach(rep => {
            let csvData= [];
                  let newReport = {};
                  newReport.updatedDate = rep.updatedDate;
                  newReport.id = rep.id
                  newReport.isPremium = rep.isPremium
                  if (rep.inputData) {
                    JSON.parse(rep.inputData).map(el => {
                      if (el) {
                        let newItem = {};
                        newItem.Symbol = el.Symbol;
                        newItem.Quantity = Math.abs(el.Quantity);
                        newItem.BuyDate = el.BuyDate;
                        newItem.BuyPrice = el.BuyPrice;
                        newItem.Type = el.Quantity ? ((el.Quantity).toString().includes('-') ? 'Sell' : 'Buy') : '';
                        csvData.push(newItem);
                      }
                    })
                    let csvContent = "Symbol,Quantity,BuyDate,BuyPrice,Type\n";
                    csvContent += [...csvData.map(item => Object.values(item).join(","))].join("\n").replace(/(^\[)|(\]$)/gm, "");
                    newReport.csv = csvContent;
                    self.totalPremReports.push(newReport);
                  }
          })
        }
      });
    },
    exportToCSV (report) {
      CSVExport.exportCSV(report.csv, "Reports.csv");
    },

    async fetchusersubscription () {
      await this.getusersubscription().then(data => {
        if (data == null) {
          this.subscriptiondata = false
        }
      });
      this.subscriptionLoading = true;
    },

    navigateToEvaluation() {
      localStorage.removeItem('preLoginHoldingsData')
      localStorage.removeItem('reEvaluatePortfolioData')
      localStorage.removeItem('HoldingsData')
      localStorage.removeItem('ShowLastHoldingdata')
      this.$router.replace({ name: 'evaluation', query: { clear: 'true' } })
    },

    onPortfolioCardKeydown(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        event.currentTarget.click();
      }
    },

    navigateToLastUnsavedEvaluation() {
      localStorage.removeItem('preLoginHoldingsData')
      localStorage.removeItem('reEvaluatePortfolioData')
      localStorage.removeItem('HoldingsData')
      localStorage.setItem('ShowLastHoldingdata', true);
      this.$router.replace({ name: 'evaluation', query: { clear: 'false' } })
    },

    async generatelastportfolioinsight(data) {
      if (this.subscription) {
        this.isPremium = this.subscription.remainingAccess > 0 ? true : false
      }
      const formData = new FormData();
        formData.append(
          "user_portfolio_data",
          data.inputData
        );
        formData.append("portfolio_id", 7);
        formData.append("rec_id", 0);
        formData.append("cash", 0);
        formData.append("allowShortSell", 0);
        formData.append("is_premium", data.isPremium);
        formData.append("client_id",1);
        await this.generatelastportfolio(formData).then(data => {
          this.lastPortfolioInsight = data.data
        })
    },

    async fetchAgreement() {
        try {
            const response = await axios.get('https://esign-api-dot-qsi-gcloud-prod.el.r.appspot.com/esign/api/userlegalagreement/agreementtype.json', {
                params: {
                    productCode: 'psi',
                    agreementtype: 3,
                },
            });
            this.legalAgreementContentEsign = response.data.data.description;
            this.isEsignActive = response.data.data.isEsign === 1;
        } catch (error) {
        }
    },

    async checkEsignStatus() {
      try {
          const userId = localStorage.getItem("uid");
          const productType = "psi";
          const response = await axios.get("https://esign-api-dot-qsi-gcloud-prod.el.r.appspot.com/esign/api/user/isEsignDone.json", {
              params: { userId, productType }
          });
          const responseData = response?.data?.data;

          if (responseData?.success === false) {
              this.esignRecord = {
                  id: responseData.id ?? null,
                  UserId: responseData.UserId ?? null,
                  product: responseData.product ?? null,
                  transactionId: responseData.transactionId ?? null,
                  pdflink: responseData.pdflink ?? null,
                  createdDate: responseData.createdDate ?? null,
                  updatedDate: responseData.updatedDate ?? null
              };
              this.fetchAgreement();
              this.showEsign = true;
          } else {
              this.showEsign = false;
              
          }
      } catch (error) {
      }
    }

  }
}





// WEBPACK FOOTER //
// ./src/assets/js/Dashboard.js